export enum TerminalNames {
  SIX = 'six',
  OPI = 'opi',
  MINI = 'mini',
  SUMUP = 'sumup',
  PAYMASH_PAY = 'paymashpay',
  GLASS = 'mypos-glass',
  SOFTPOS = 'softpos',
}
